import React, { useCallback, useEffect, useMemo, useState } from 'react'

import {
  ModalContent,
  ModalActions,
  Header,
  Modal,
} from 'semantic-ui-react'
import { Button, ButtonProps, Icon, Label, Popup } from "semantic-ui-react";
import CardChoosePaidTypePackageModal from 'react-lib/apps/MEH/CardChoosePaidTypePackageModal';
import CardTransactionSummaryModal from 'react-lib/apps/MEH/CardTransactionSummaryModal';
import PaymentResultModal from 'react-lib/apps/MEH/PaymentResultModal';
import Payment2C2PModal from "react-lib/apps/MEH/Payment2C2PModal";

type PackageCartNotificationMessageType = {
  BillingAndPackageSequence: any;
  BillingCarts: any;
  runSequence: any;
  controller: any;
  setProp: any;
  tabAdminRef: any;
  userProfile: any;
}
const PackageCartNotificationMessage = (props: PackageCartNotificationMessageType) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    props.runSequence({ sequence: "BillingAndPackage", restart: true });
    return () => {
      props.runSequence({ sequence: "BillingAndPackage", clear: true });
    };
  }, [props.controller.division]);

  // Constants
  const styles = {
    box: {
      backgroundColor: "unset",
      borderRadius: "5px",
      boxShadow: "0px 2px 5px 0px rgba(0, 0, 0, 0.1)",
      margin: "0.1rem 0.25rem 1rem",
    },
    button: { width: "11rem" },
    buttonActive: { backgroundColor: "var(--primary-theme-color)", color: "white", width: "11rem" },
    icon: {
      color: "white",
      cursor: "pointer",
      fontSize: "1.4em",
    },
    popup: { minWidth: "43rem" },
  };

  return (
    <>
      <div
        style={{ marginRight: "22px", position: "relative" }}
        onClick={() => {
          props.setProp("BillingAndPackageSequence", {
            ...props.BillingAndPackageSequence,
            openTransactionModal: true,
          });
        }}
      >
        <div>
          {(props.BillingCarts?.items || []).length > 0 ? (
            <div
              style={{
                top: "-8px",
                position: "absolute",
                right: "-7px",
              }}
            >
              <Label circular color="red" size="mini">
                {" "}
                {
                  (props.BillingCarts?.items || [])?.filter((i: any) => i.status === "BILLED")
                    .length
                }{" "}
              </Label>
            </div>
          ) : (
            <></>
          )}
          <Icon style={styles.icon} name="cart" />
        </div>
      </div>

      {props.BillingAndPackageSequence?.openTransactionModal ? (
        <CardTransactionSummaryModal
          BillingAndPackageSequence={props.BillingAndPackageSequence}
          controller={props.controller}
          BillingCarts={props.BillingCarts}
          runSequence={props.runSequence}
          setProp={props.setProp}
        />
      ) : null}
      {props.BillingAndPackageSequence?.openPaidTypePackageModal ? (
        <CardChoosePaidTypePackageModal
          BillingAndPackageSequence={props.BillingAndPackageSequence}
          runSequence={props.runSequence}
          setProp={props.setProp}
          userProfile={props.userProfile}
        />
      ) : null}
      {props.BillingAndPackageSequence?.openPaidResultModal ? (
        <PaymentResultModal
          BillingAndPackageSequence={props.BillingAndPackageSequence}
          runSequence={props.runSequence}
          setProp={props.setProp}
          tabAdminRef={props.tabAdminRef}
        />
      ) : null}

      {props.BillingAndPackageSequence?.open2C2PPaymentModal ? (
        <Payment2C2PModal
          data={props.BillingAndPackageSequence}
          onSuccess={() =>
            props.runSequence({ sequence: "BillingAndPackage", action: "2C2P_SUCCESS" })
          }
          onCanceled={() =>
            props.runSequence({ sequence: "BillingAndPackage", action: "2C2P_CANCELED" })
          }
          onUnknown={() =>
            props.runSequence({ sequence: "BillingAndPackage", action: "2C2P_UNKNOWN" })
          }
        />
      ) : null}
    </>
  );
}

export default PackageCartNotificationMessage